<template>
    <v-container>
        <v-data-table :headers="headers" :items="wishlists">
            <template v-slot:[`item.media`]="{
                    item,
                }">
                <v-container v-if="item" class="d-flex justify-self-center pa-0 feathered">
                    <v-img v-if="!$mobile" width="150" height="200" lazy-src="https://picsum.photos/id/497/1080/1080" @click="item.media.length ?
                            imageOverlays[item.id] = !imageOverlays[item.id] : ''
                        " :src="$near.ipfsAdapter(item.media)"></v-img>
                    <v-overlay z-index="10" :value="isOverlayOn(item.id)" @click="
                            imageOverlays[item.id] = !imageOverlays[item.id]
                        ">
                        <v-img class="rounded-xl" :src="$near.ipfsAdapter(item.media)"></v-img>
                    </v-overlay>
                </v-container>
            </template>
            <template v-slot:[`item.id`]="{
                    item,
                }">
                <router-link :to="{ path: `/wishlist/${item.id}` }" class="no-decoration ml-2" style="text-decoration: none">{{ item.id }}</router-link>
            </template>
            <template v-slot:[`item.items`]="{
                    item,
                }">
                <v-container class="d-flex justify-self-center pa-0 feathered" v-if="item">
                    <v-img v-for="wishlistItem of withMediaFilter(item)" v-bind:key="`img-${overlayId(item, wishlistItem)}`" :width="withMediaFilter(item).length ? 150 / withMediaFilter(item).length : 150" height="200" lazy-src="https://picsum.photos/id/497/1080/1080" @click="
                            imageOverlays[overlayId(item, wishlistItem)] = !imageOverlays[overlayId(item, wishlistItem)]
                        " :src="$near.ipfsAdapter(wishlistItem.media)"></v-img>
                    <v-overlay v-for="wishlistItem of withMediaFilter(item)" v-bind:key="overlayId(item, wishlistItem)" z-index="10" :value="isOverlayOn(overlayId(item, wishlistItem))" @click="
                            imageOverlays[overlayId(item, wishlistItem)] = !imageOverlays[overlayId(item, wishlistItem)]
                        ">
                        <v-img class="rounded-xl" :src="$near.ipfsAdapter(wishlistItem.media)"></v-img>
                    </v-overlay>
                </v-container>
            </template>
        </v-data-table>
    </v-container>
</template>
<style scoped>
</style>
<script>
export default {
    name: 'BnftWishlists',
    components: {},
    props: {},
    methods: {
        async get() {
            const self = this;
            this.$near
                .wishlist({
                    functionName: 'wishlists',
                })
                .then((wishlists) => {
                    self.$backend
                        .sharedWishlists({
                            ids: wishlists,
                        })
                        .then((wishlists) => (self.wishlists = wishlists));
                });
            this.$near
                .wishlist({
                    functionName: 'giver_ids',
                })
                .then((giver_ids) => (self.giverIds = giver_ids));
        },
        isOverlayOn(overlayId) {
            if (this.imageOverlays[overlayId] === undefined)
                this.$set(this.imageOverlays, overlayId, false);
            return (
                this.imageOverlays[overlayId] && this.flickerTimeout
            );
        },
        withMediaFilter(wishlist) {
            return wishlist && wishlist.items ? wishlist.items.filter(item => item.media && item.media.length) : [];
        },
        overlayId(wishlist, item) {
            return wishlist?.id && item?.id?.gtin ? `${wishlist.id}:${item.id.gtin}` : undefined;
        }
    },
    data: function () {
        return {
            ipfsCompatible: undefined,
            wishlists: undefined,
            giverIds: undefined,
            imageOverlays: {},
            headers: [
                { text: `media`, value: 'media' },
                { text: `owner`, value: 'owner' },
                { text: `id`, value: 'id' },
                { text: `items`, value: 'items' },
            ],
            flickerTimeout: false,
        };
    },
    computed: {},
    watch: {
        wishlists(value) {
            const self = this;
            value.map(wishlist => wishlist.items.map(item => self.$set(self.imageOverlays, self.overlayId(wishlist, item), false)));
        }
    },
    mounted() {
        const self = this;
        setTimeout(() => (this.flickerTimeout = true), 1500);
        (async () => {
            try {
                self.get();
            } catch (error) {
                console.error(error);
                return error;
            }
        })();
    },
};
</script>
